import React, { useState, useEffect } from "react";
import styles from "./index.module.scss";
import FormItem from "../../../maintence/components/FormItem";
import Choice from "../../../maintence/components/Choice";
import Picker from "../../../../components/Picker";

interface IAllProvinceAndCity {
  value: string; //省份编码
  label: string;
  children: { value: string; label: string }[];
}

interface IProps {
  allProvinceAndCity: IAllProvinceAndCity[]; //初始的所有省市
  initialProvinceCity: {
    province: string;
    city: string;
  };
  handleConfirm: (cCode) => void;
}

export default function SelectStoreCity({
  allProvinceAndCity,
  initialProvinceCity,
  handleConfirm,
}: IProps) {
  const [showPickupCity, setShowPickupCity] = useState(false);
  const [pickupCityOptions, setPickupCityOptions] = useState<{
    province: string[];
    city: string[];
  }>({
    province: [],
    city: [],
  });
  const [pickupCityValues, setPickupCityValues] = useState<{
    province: string;
    city: string;
  }>(initialProvinceCity);
  const [provinceCityValues, setProvinceCityValues] = useState<{
    province: string;
    city: string;
  }>(initialProvinceCity);

  useEffect(() => {
    const cities: string[] = [];
    const provinces: string[] = [];
    allProvinceAndCity.forEach((item) => {
      provinces.push(item.label);
    });
    allProvinceAndCity[0]?.children.forEach((item1) => {
      cities.push(item1.label);
    });
    setPickupCityOptions({
      province: provinces,
      city: cities,
    });
  }, []);
  useEffect(() => {
    setPickupCityValues(initialProvinceCity);
    setProvinceCityValues(initialProvinceCity);
  }, [initialProvinceCity]);

  const handleChangePickupCity = (name, value) => {
    console.log(name, value);
    if (name === "province") {
      const curCities: string[] = [];
      let firstCity: string = "";
      allProvinceAndCity.forEach((item) => {
        if (item.label === value) {
          if (Array.isArray(item.children)) {
            item.children.forEach((item1: any) => {
              curCities.push(item1.label);
              if (!firstCity) {
                firstCity = item1.label;
              }
            });
          }
        }
      });
      setPickupCityOptions({
        province: pickupCityOptions.province,
        city: curCities,
      });
      setPickupCityValues({
        province: value,
        city: firstCity,
      });
    } else if (name === "city") {
      setPickupCityValues({
        province: pickupCityValues.province,
        city: value,
      });
    }
  };

  const handleConfirmPickupCity = () => {
    const cityCode = getCityCodeByProvinceCity(
      pickupCityValues.province,
      pickupCityValues.city
    );
    // 点击确定时更新省市
    setProvinceCityValues({
      province: pickupCityValues.province,
      city: pickupCityValues.city,
    });
    //根据城市code获取服务门店列表
    console.log(cityCode, "选择好的城市的citycode");
    setShowPickupCity(false);
    let obj = {
      cityCode:parseInt(cityCode),
      province:pickupCityValues.province,
      city:pickupCityValues.city
    }
    handleConfirm(obj);
  };

  /**
   * 根据省市遍历allProvinceAndCity获取城市code
   * @param province 省
   * @param city 市
   */
  const getCityCodeByProvinceCity = (province, city) => {
    let cityCode = "";
    allProvinceAndCity.forEach((provinceItem) => {
      if (provinceItem.label === province) {
        provinceItem.children.forEach((cityItem) => {
          if (cityItem.label === city) {
            cityCode = cityItem.value;
          }
        });
      }
    });
    return cityCode;
  };

  const showPickupProvinceCity = () => {
    // 如果没有定位的值，默认显示第一个省和市
    if (pickupCityValues.province === "" && pickupCityValues.city === "") {
      console.log("如果没有定位的值，默认显示第一个省和市");
      setPickupCityValues({
        province: pickupCityOptions.province[0],
        city: pickupCityOptions.city[0],
      });
    } else {
      // 得到省需要刷新省对应的市
      const cities: string[] = [];
      console.log(allProvinceAndCity, "定位后是否有地址信息");
      allProvinceAndCity.forEach((item) => {
        if (item.label === pickupCityValues.province) {
          item.children.forEach((item1) => {
            cities.push(item1.label);
          });
        }
      });
      setPickupCityOptions({
        province: pickupCityOptions.province,
        city: cities,
      });
    }

    setShowPickupCity(true);
  };

  return (
    <div>
      <div className={styles.picker}>
        <FormItem label="选择门店所在城市">
          <Choice
            placeholder="请选择"
            onClick={() => {
              showPickupProvinceCity();
            }}
          >
            {provinceCityValues.province !== "" &&
            provinceCityValues.city !== ""
              ? `${provinceCityValues.province} ${provinceCityValues.city}`
              : ""}
          </Choice>
        </FormItem>
      </div>
      {showPickupCity && (
        <Picker
          onCancel={() => {
            setShowPickupCity(false);
          }}
          onChange={handleChangePickupCity}
          onConfirm={handleConfirmPickupCity}
          valueGroups={pickupCityValues}
          optionGroups={pickupCityOptions}
        ></Picker>
      )}
    </div>
  );
}
